/* eslint-disable @typescript-eslint/no-explicit-any */
import { getClient } from '~/lib/contensis/client'
import { Op, OrderBy, Query } from 'contensis-delivery-api'
import { isDevelopment } from '~/utils/misc'

export const NewsPage = async (loc: URL) => {
  const client = getClient()
  const entryId = loc.searchParams.get('entryId') as string

  try {
    const result = await client.entries.get({
      id: entryId,
      fields: [
        // 'heading',
        // 'description',
        // 'date',
        // 'image',
        // 'canvas',
        // 'categories',
        // 'entryTitle',
        // 'attribution',
        // 'relatedNews',
        // 'seoStandard',
        // 'sys.version',
        // 'video',
        // 'category',
        // 'placeholderImage',
        // 'youtubeCode',
        // 'transcript',
        // 'duration',
        // 'id',
        // 'relatedNews.image'
      ],
      fieldLinkDepths: {
        attribEntry: 1
        // categories: 1,
        // relatedNews: 1,
        // canvas: 2
      }
    })

    return result
  } catch (err) {
    console.log(err)
  }
}

export const NewsArticlesQuery = async (page = 0, category = '', size = 10) => {
  const client = getClient()

  // console.log(page, category, size)

  const query = new Query(
    Op.equalTo('sys.versionStatus', isDevelopment ? 'latest' : 'published'),
    Op.equalTo('sys.contentTypeId', 'pageNewsArticle'),
    Op.equalTo('seoStandard.search', true),
    Op.equalTo('sys.dataFormat', 'entry')
  )

  if (category) {
    query.where.add(Op.and(Op.equalTo('categories.entryDescription', category)))
  }

  query.orderBy = OrderBy.desc('date')
  query.pageSize = size
  query.pageIndex = page
  query.fields = ['entryTitle', 'description', 'date', 'image']

  try {
    const result = await client.entries.search(query)
    // console.log('result', result)
    return result
  } catch (err) {
    console.log(err)
  }
}
